@if (chartConfigurationData) {
    <canvas
        #chartCanvas
        baseChart
        [width]="width"
        [height]="height"
        [type]="chartType"
        [datasets]="chartConfigureDataset"
        [options]="chartConfigurationData.chartOptions"
    >
    </canvas>
}
